<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        <div *ngIf="modeService.isIosMode()">Abbrechen</div>
        <div *ngIf="!modeService.isIosMode()">
          <ion-icon name="close-outline" slot="icon-only" size="large"></ion-icon>
        </div>
      </ion-button>
    </ion-buttons>
    <ion-title>Bericht erstellen</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="save()" [disabled]="!this.reportForm.valid" [strong]="true">Erstellen</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <form [formGroup]="reportForm" class="bg-iosbackground dark:bg-transparent pt-5">
    <ion-list>
      <ion-item>
        <ion-note slot="start">
          <ion-icon color="primary" name="document-outline" class="text-lg"></ion-icon>
        </ion-note>
        <ion-select label="Bericht" formControlName="report_id" okText="Festlegen" cancelText="Abbrechen" (ionChange)="updateTimeSelection($event?.detail?.value)">
          @for (reportConfiguration of reportConfigurationsSignal(); track reportConfiguration.report_configuration_id) {
            <ion-select-option [disabled]="!hasAccess(reportConfiguration)" [value]="reportConfiguration.report_id">
              {{ reportConfiguration.report_name }}
            </ion-select-option>
          }
        </ion-select>
      </ion-item>
    </ion-list>
    <ion-list>
      <ion-item lines="full">
        <ion-note slot="start">
          <ion-icon color="primary" name="time-outline" class="text-lg"></ion-icon>
        </ion-note>
        <ion-select label="Zeitspanne" okText="Festlegen" cancelText="Abbrechen" [value]="timeRangeSelectionSignal()" (ionChange)="updateTimeSpan($event?.detail?.value)">
          <ion-select-option value="all">Gesamt</ion-select-option>
          <ion-select-option value="1w">1 Kalenderwoche</ion-select-option>
          <ion-select-option value="2w">2 Kalenderwochen</ion-select-option>
          <ion-select-option value="1m">1 Kalendermonat</ion-select-option>
          <ion-select-option value="2m">2 Kalendermonate</ion-select-option>
          <ion-select-option value="1y">1 Kalenderjahr</ion-select-option>
          <ion-select-option value="custom">Benutzerdefiniert</ion-select-option>
        </ion-select>
      </ion-item>
    </ion-list>
    <ion-list class="mt-5 mb-5" [ngClass]="!customDateRange ? 'hidden' : ''">
      <ion-item>
        <ion-note slot="start">
          <ion-icon color="primary" name="time-outline" class="text-lg"></ion-icon>
        </ion-note>
        <ion-input label="Von" formControlName="start_date" placeholder="Startdatum" type="date"></ion-input>
      </ion-item>
      <ion-item lines="full">
        <ion-note slot="start">
          <ion-icon class="-mt-1 text-lg"></ion-icon>
        </ion-note>
        <ion-input label="Bis" formControlName="end_date" placeholder="Enddatum" type="date"></ion-input>
      </ion-item>
    </ion-list>
    <ion-list class="mt-5 mb-5">
      <ion-item lines="full">
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="folder-outline"
            class="text-lg"
          ></ion-icon>
        </ion-note>
        <ion-toggle formControlName="storage_save"
          >In Ablage speichern</ion-toggle
        >
      </ion-item>
      @if (reportForm.get('student_id').value) {
        <ion-item lines="none">
          <ion-note slot="start">
            <ion-icon
              color="primary"
              name="mail-outline"
              class="text-lg"
            ></ion-icon>
          </ion-note>
          <ion-toggle formControlName="student_mail_direct"
            >An {{studentName()}} senden</ion-toggle
          >
        </ion-item>
      } 
      <!-- @else {
        <ion-item lines="none">
          <ion-note slot="start">
            <ion-icon
              color="primary"
              name="mail-outline"
              class="text-lg"
            ></ion-icon>
          </ion-note>
          <ion-toggle formControlName="mail_direct"
            >Als E-Mail erhalten</ion-toggle
          >
        </ion-item>
      } -->
    </ion-list>
  </form>
</ion-content>
